import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const Notifications = ({notificationsLoading,notifications, schedules, schedulesLoading}) => {
  const [dayArray, setDayArray] = useState([])
  useEffect(() => {
    let arr = notifications?.map(notification => new Date(notification?.date).toDateString())
    arr = arr?.filter((item,index) => arr.indexOf(item) === index);
    setDayArray(arr)
  },[notifications])
  
  return (
    <div className='main-container'>
      <div className='card w-full mx-auto md:ml-20 mt-2 lg:h-[90vh] flex flex-col gap-3 overflow-hidden'>
        <div className="h-full px-8 py-4 pt-10 flex flex-col gap-4">
          <div className='flex flex-col gap-4 w-full h-full notification-wrapper overflow-y-auto scrollbar-none'>
            {notificationsLoading && schedulesLoading ? (
              <div className='flex flex-col gap-3'>
                <div className='bg-[#aaa]/10 w-[20%] h-[1.5rem] rounded-2xl'/>
                <div className='bg-[#aaa]/10 w-full h-[5rem] rounded-2xl'/>
                <div className='bg-[#bbb]/10 w-full h-[5rem] rounded-2xl'/>
                <div className='bg-[#ccc]/10 w-full h-[4rem] rounded-2xl'/>
              </div>
            ) : dayArray?.map(d => (
              <div key={d} className='flex flex-col gap-2'>
                <span className='capitalize text-sm font-medium'>
                  {d === new Date().toDateString() 
                    ? 'today'
                    : new Date().getDate() - new Date(d).getDate() === 1 
                      && new Date().getMonth() === new Date(d).getMonth() 
                      && new Date().getFullYear() === new Date(d).getFullYear()
                        ? 'Yesterday'
                        : new Date(d)?.toLocaleString('en-in',{day :'numeric', month :'short', year :'numeric'})
                  }
                </span>
                <ul>
                    {notifications
                      ?.filter(notification => new Date(notification?.date)?.toDateString() === d)
                      ?.map(notification => {
                        const candidateName = schedules?.filter((schedule) => schedule?.UID === notification?.uid)[0]?.Name
                        return(candidateName &&
                          <li className='relative' key={notification.id}>
                            <Link
                              to = {`/candidateProfile?id=${notification?.uid}`}
                              className='absolute top-0 left-0 h-full w-full'
                            ></Link>
                            <div className='user-profile-inline'>
                              <div className='profile-pic'>
                                <img src="/img/adminProfile.png" alt="profile pic" />
                              </div>
                              <div className='profile-content'>
                                {candidateName}
                                <span className='detail text-sm'>
                                  {notification?.notificationBody}
                                </span>
                              </div>
                            </div>
                            <div className='right-item'>
                              <div className='time'>{new Date(notification?.time)?.toLocaleTimeString("en-in",{hour:'numeric', minute:'numeric'})}</div>
                            </div>
                          </li>
                        )
                    })
                    }
                </ul>
              </div>
            ))}
            
          </div>
        </div>
      </div>
    </div>
  )
}

export default Notifications
